import DataCard from '@/app-theme/components/common/DataCard.vue'
import DialogVisible from '@/app-core/mixins/dialog/dialogVisible.js'

export default {
  name      : 'ConfirmPinDialog',
  components: {DataCard},
  directives: {},
  mixins    : [DialogVisible],
  props     : {
    title: {
      type   : String,
      default: ''
    },
    subTitle: {
      type   : String,
      default: ''
    },
    message: {
      type   : String,
      default: ''
    },
    options: {
      type   : Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      inputData     : '',
      config        : {},
      defaultOptions: {
        icon         : 'mdi-alert',
        input        : '',
        color        : 'error',
        dense        : false,
        width        : 610,
        persistent   : true,
        dark         : false,
        coloredBorder: true,
        button       : {
          no : {title: this.$t('Common.Button.No')},
          yes: {title: this.$t('Common.Button.Yes')}
        }
      }
    }
  },
  computed: {
    isValid() {
      return !!this.inputData && this.inputData.length === 6
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) this.initDialog()
    }
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    initDialog() {
      this.inputData = ''
      this.config = {...this.defaultOptions, ...this.options}
    },

    confirmDialog() {
      this.$emit('dialog:yes', this.inputData)
    }
  }
}
